

const Footer = () => {
    return (
        <footer>
        <div className="connect">
            <p className="footer">&copy; 2023 Christopher Hile</p>
            <a href="mailto:christopherhileweb@gmail.com">Email: christopherhileweb@gmail.com</a>
            <a href="tel:9379011405">Phone: 937-901-1405</a>
        </div>
        
    </footer>
    )
}

export default Footer;